import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=81c60b80&scoped=true&"
import script from "./FieldSelector.vue?vue&type=script&lang=js&"
export * from "./FieldSelector.vue?vue&type=script&lang=js&"
import style0 from "./FieldSelector.vue?vue&type=style&index=0&id=81c60b80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c60b80",
  null
  
)

export default component.exports